module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.ready),
      expression: "!ready"
    }],
    staticClass: "product-lines-loading-wrap",
    staticStyle: {
      "width": "100%",
      "min-height": "220px",
      "position": "relative"
    },
    attrs: {
      "element-loading-text": _vm.$t('static.loadingProductLines')
    }
  }, [(_vm.ready) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    attrs: {
      "form": _vm.form,
      "list": _vm.billProductsList,
      "additionalButtons": _vm.additionalButtons,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": "table.billProducts",
      "disableForm": _vm.bill.billStatusId === 3 || _vm.bill.billStatusId === 4 || _vm.bill.billStatusId === 5,
      "stack": {
        price: 'productDepositName',
        orderProductId: 'billNote'
      },
      "clickHandler": _vm.tableClickHandler,
      "columnWidths": _vm.columnWidths,
      "hiddenFields": _vm.hiddenFields
    }
  }), _vm._v(" "), _c('v-totals-table', {
    attrs: {
      "list": _vm.totalsTableList
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6973afd3","hasScoped":false}!./src/app/components/billProductsTable/billProductsTable.html
// module id = 3045
// module chunks = 1